exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 991px){\n.nav-mobile-menu[data-v-2fd0de74]{display:none\n}\n}\n.sidebar[data-v-2fd0de74]{display:flex;flex-direction:column\n}\n.sidebar .sidebar-footer[data-v-2fd0de74]{padding-left:30px;padding-bottom:20px;color:#fff\n}\n.sidebar .logo-img img[data-v-2fd0de74]{width:100%\n}\n.sidebar .logout-link[data-v-2fd0de74]{padding:.5em 1.25em\n}", ""]);

// exports
